v<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'
import Vue from 'vue'

import { deviceApi } from '@router/apiFiles/deviceApi'
import { customerApi } from '@router/apiFiles/customerApi'
import Information from '@components/information'

export default {
	page: {
		title: 'Install devices',
		meta: [{ name: 'description', content: appConfig.description }],
	},
	components: { Layout, PageHeader, Information },
	data() {
		return {
			tableData: [],
			isBusy: true,
			title: 'Install devices',
			items: [
				{
					text: 'OnBoard',
					href: '/',
				},
				{
					text: 'Devices',
					href: '/',
				},
				{
					text: 'Install devices',
					active: true,
				},
			],
			customerId: '',
			customers: [],
			deviceModels: [],
			deviceModelId: '',
			toInsert: [],
			showInformation: false,
			informationText: ''
		}
	},

	mounted() {
		this.fetchData().catch(error => {
		    console.error(error)
		})
	},
	methods: {		
        async fetchData() {
			var self = this;
			self.isBusy = true;			
		},
		importFile() {
			var self = this;
			if (this.file1) {
				this.showImportFile = false;
				console.log(this.file1);
				console.log(this.file1.blob);
				var fr = new FileReader();
				fr.onload = function(e) {
					var content = e.target.result;
					var lines = content.split('\n');
					self.processFile(lines);
				}
				fr.readAsText(this.file1, "UTF-8");
			}
		},
		async processFile(lines) {
			this.isBusy = true;
			var self = this;
			self.toInsert = [];
			lines.forEach((line, index) => {
				console.log('line:' + line);
				if (line.indexOf('modem') != -1) {}
				else if (line.length > 5) {
					if (line.indexOf(';') == -1) {
						self.informationText = "Error on line " + (index + 1);
						self.showInformation = true;
						return;
					}
					var readyText = line.replace("\r", "").replace("\n", "");
					while(readyText.indexOf('"') != -1) readyText = readyText.replace('"','');
					var importData = readyText.split(';');
					if (importData == null || importData.length != 2) {
						self.informationText = "Error on line " + (index + 1);
						self.showInformation = true;
						return;
					}
					self.toInsert.push({ modem:importData[0], chassis:importData[1] });
				}
			});
			this.isBusy = false;
			this.confirmImport();
		},
		confirmImport() {
			var self = this;
			if (self.toInsert.length > 0) {
				deviceApi.installDeviceBulk({ devices: self.toInsert })
					.then(function (data) {
						self.informationText = "Success! File imported.";
						self.showInformation = true;
					});	
			
			}
		},
		downloadModel: function(){
			let csv = 'modem;chassis\n';
			let model = [ { modem: '0-0000000', chassis: 'CCCCCCCCCCCCCCCCCC' }];
			model.forEach(el => {
				var line = el['modem'] + ';' + el['chassis'] + '\n';
				csv += line;
			})
			var blob = new Blob([ csv ], { "type" : "csv/plain" });
			let link = document.createElement('a')
			link.href = window.URL.createObjectURL(blob)
			link.download = 'installModel.csv'
			link.click()
		}		
	},
}
</script>
<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<p class="text-muted font-13 mb-4"></p>
						<div class="row mb-md-2">						
							<div class="col-md-12">
								<b-alert show variant="light">First get the importation file model <a href="javascript: void(0);" @click="downloadModel()" class="btn btn-primary btn-sm">Here<i class="uil uil-file-download-alt"></i></a>. Fill the model and then submit it below:</b-alert>
							</div>
							
							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<b-form-file v-model="file1" accept=".csv" :state="Boolean(file1)" placeholder="Choose a file or drop it here" drop-placeholder="Drop a file here"></b-form-file>
								</div>
							</div>


							<div class="col-sm-6 col-md-4">
								<div class="form-group">
									<b-button variant="primary" @click="importFile()" >Submit file</b-button>
								</div>
							</div>

						</div>


					</div>
				</div>
			</div>
		</div>
		
		<information :informationtext="informationText" :showDialog="showInformation" @ok="showInformation=false" />
		
	</Layout>
</template>
